import React, { ReactElement } from 'react'
import FinancialInformation from '../../../components/verification-steps/steps/questionnaire/FinancialInformation'
import verificationStore from '../../../stores/verificaton.store'

const UserFinicialInformation: React.FC = (): ReactElement => {
  return <FinancialInformation verificationStore={verificationStore} />
}
export default UserFinicialInformation
